import * as tslib_1 from "tslib";
import m from 'mithril';
import objectToFormData from 'object-to-formdata';
import { FormStatus, FormStore } from '../store/formstore';
import { Boxes, Checkbox, Fields, Input, Radios, Select, Textarea } from '../ui/form/fields';
var FormBase = /** @class */ (function () {
    function FormBase(store, fields) {
        var _this = this;
        this.store = store;
        this.fields = fields;
        this.text = function (config) { return _this.fields.asField(Input, tslib_1.__assign({}, config)); };
        this.email = function (config) { return _this.text(tslib_1.__assign({}, config, { type: 'email' })); };
        this.password = function (config) { return _this.text(tslib_1.__assign({}, config, { type: 'password' })); };
        this.textarea = function (config) { return _this.fields.asField(Textarea, tslib_1.__assign({}, config)); };
        this.select = function (config) { return _this.fields.asField(Select, config); };
        this.radio = function (config) { return _this.fields.asField(Radios, config); };
        this.checkbox = function (config) { return _this.fields.asField(Checkbox, config); };
        this.boxes = function (config) { return _this.fields.asField(Boxes, config); };
    }
    FormBase.prototype.status = function () {
        return this.store.status.type;
    };
    FormBase.prototype.isCompleted = function () {
        return this.status() == FormStatus.Success;
    };
    FormBase.prototype.formSubmit = function (e, options) {
        if (options === void 0) { options = {}; }
        e.preventDefault();
        var form = e.target;
        var url = form.action, method = form.method;
        var type = form.getAttribute('enctype') || 'application/json';
        return this.submit(type, tslib_1.__assign({ url: url, method: method }, options));
    };
    FormBase.prototype.submit = function (type, options) {
        var _this = this;
        var url = options.url, method = options.method, _a = options.headers, headers = _a === void 0 ? {} : _a, rest = tslib_1.__rest(options, ["url", "method", "headers"]);
        switch (this.store.status.type) {
            case 'sending':
            case 'success':
                return Promise.resolve();
            default:
                return this.transfer(tslib_1.__assign({ url: url,
                    method: method, data: this.formatData(type), headers: type.indexOf('multipart') === 0
                        ? headers
                        : tslib_1.__assign({ 'Content-Type': type }, headers), serialize: function (v) { return v; } }, rest)).then(function (response) { return Promise.resolve(_this.store.success(response)); }, function (errors) { return Promise.reject(_this.store.fail(errors)); });
        }
    };
    FormBase.prototype.formatData = function (type) {
        switch (type) {
            case 'application/x-www-form-urlencoded':
                return m.buildQueryString(this.store.data);
            case 'multipart/form-data':
                return objectToFormData(this.store.data);
            case 'application/json':
                return JSON.stringify(this.store.data);
        }
    };
    FormBase.prototype.transfer = function (request) {
        var _this = this;
        return m.request(tslib_1.__assign({}, request, { config: function (xhr) {
                _this.store.send(xhr);
            } }));
    };
    return FormBase;
}());
export { FormBase };
/**
 * Als instance klasse van de view waar je de form wilt gebruiken maak je een nieuw Form aan.
 * Het onsubmit event van je html formulier koppel je door aan de submit methode van dit form object.
 * Velden toevoegen aan je html formulier is gemakkelijk via de shortcurts die je vind op dit form object.
 * Wanneer het onsucces event wordt aangeroepen weet je dat het formulier succesvol verwerkt is door de server.
 *
 * Eigen custom velden maken en toevoegen kan door de attrs methode te gebruiken (zie implementatie shortcuts).
 * Een eigen veld moet ten minste de attributes 'value' en 'onchange' ondersteunen om te functioneren.
 *
 * Langs de serverkant moet je een route voorzien die de data verwerkt.
 * Deze stuurt een json bericht terug van volgende type:
 * {
 *      "succes": true | false
 *      "errors": { ... }           // Alleen als succes false is
 *      "data": { ... }             // Alleen als succes true is (wordt meegegeven als argument aan de onsucces)
 * }
 *
 * TODO:
 * - Gebruik de setCustomValidity methode om de in-browser validatie toe te passen op elementen met een error
 * - Select vervangen door geheel eigen implementatie (die makkelijker te stylen is als de standaard html select)
 * - Een flexibel en veilig wysiwyg-editor veld toevoegen (bv. tinymce)
 * - Basis styling van bestaande elementen robuuster en flexibeler maken
 */
var Form = /** @class */ (function (_super) {
    tslib_1.__extends(Form, _super);
    function Form(_a) {
        if (_a === void 0) { _a = {}; }
        var _b = _a.data, data = _b === void 0 ? {} : _b, config = tslib_1.__rest(_a, ["data"]);
        var _this = this;
        var store = new FormStore(data);
        var fields = new Fields(store, tslib_1.__assign({ defaultUnstyled: true, labelInFields: false, defaultRequired: false }, config));
        _this = _super.call(this, store, fields) || this;
        return _this;
    }
    Form.prototype.formSubmit = function (e, options) {
        var _this = this;
        return _super.prototype.formSubmit.call(this, e, options).catch(function (errors) {
            var firstKey = Object.keys(errors)[0];
            if (firstKey)
                _this.fields.focusField(firstKey);
        });
    };
    return Form;
}(FormBase));
export { Form };
